module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA/ElEQVQ4jZ3SwSpEURgH8N/cbiE1VhYWymKoKXkHCyu2mlmZPICFwgJvQJ7EE1jJRilKyoadDUlTCiuxuPfU6XTnmvHfnO53vt89t/PdRq/Xk2QCx1hFjjPs4zluyhM0hmu0o9om1tDCeyhmCTxIUMg0TuJCCtcrUEgn7k/hZA0cR2MQvKyBV/geBA9r4Fb8kMIHLJdryBO6uIkb03HAORYwV+4/Vh1fBaGJF/woLuwjbUg/dQd36OMTX4qh32I7PijAZgmOsJi8MMOS4ge4x0wMT0vwV+ZxEWAbK0OgkBa6GTZGQCGdTDG3UTOb4e0f8DXHruLWpoZEfez9AmMLJrJCzw5sAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/job_ren.png
// module id = q+up
// module chunks = 1